import { useMemo } from 'react';
import { ThemeColors } from '../../theme';
import { getColorPalette, isColorPalette } from '../../utils';

export const useThemeColorPalette = (name: ThemeColors | null) => {
  const palette = useMemo(() => {
    if (!name) {
      return null;
    }
    if (!isColorPalette(name)) {
      return null;
    }
    return getColorPalette(name);
  }, [name]);

  return palette;
};
